import React from 'react';
import { AppProvider } from './contexts/AppContext';
import AccommodationOverview from './AccommodationOverview';

const App = ({ endpoint }) => {
    return (
        <AppProvider endpoint={endpoint}>
            <AccommodationOverview/>
        </AppProvider>
    );
};

export default App;
